import { render } from "./TheShareCard.vue?vue&type=template&id=af96cf5e&scoped=true"
const script = {}

import "./TheShareCard.vue?vue&type=style&index=0&id=af96cf5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af96cf5e"]])

export default __exports__